const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: 'AutoID',
		label: '系统编号',
	},
	{
		prop: 'Grade',
		label: '显示层级',
	},
	{
		prop: 'GradeText',
		label: '层级说明',
	}, {
		prop: 'CreatorName',
		label: '创建人',
	},
	{
		prop: 'CreateTime',
		label: '创建时间',
	}
];
export default headerData;